import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import TicketSaleTargetForm from 'Services/SalesManagement/Features/TicketSale/Components/TicketSaleTargetForm'
import { SELECTED_TICKET_SALE_TARGET_PARAMETER_KEY } from 'Services/SalesManagement/Features/TicketSale/Hooks/useTicketSaleTargetsWithParams'
import { useGetSingleTicketSaleTargetQuery } from 'Services/SalesManagement/Features/TicketSale/ticketSaleApi'
import useSalesManagementBreadcrumbs from 'Services/SalesManagement/Hooks/useSalesManagementBreadcrumbs'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

export default function TicketSaleTargetEditPage() {
  const { id } = useParams()
  const { data: singleTicketSaleTarget, isLoading } = useGetSingleTicketSaleTargetQuery(id ?? '', {
    skip: !id
  })
  const baseUrl = `${SALES_MANAGEMENT_ROOT_URL}/ticket-sales/ticket-sale-targets`
  const previousLocation = usePreviousLocation(
    `${baseUrl}?${SELECTED_TICKET_SALE_TARGET_PARAMETER_KEY}=${id}`
  )
  const breadcrumbs = useSalesManagementBreadcrumbs([
    {
      title: t`Ticket sales`
    },
    {
      title: t`Ticket sale targets`,
      link: baseUrl
    },
    {
      title: singleTicketSaleTarget ? singleTicketSaleTarget.identifier : ''
    }
  ])

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit ticket sale target`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        <TicketSaleTargetForm
          ticketSaleTarget={singleTicketSaleTarget}
          successBaseUrl={previousLocation}
        />
      </WithLoader>
    </Box>
  )
}
